import { useContext } from "react";

import { CurrentUserContext } from "@/context/CurrentUserContext";
import { StaffType } from "@/domain/staff";
import { useCurrentUserType } from "@/stores/authStore";

export const useCurrentStaff = () => {
  const currentStaff = useContext(CurrentUserContext);
  const currentUserType = useCurrentUserType();

  if (currentUserType !== "STAFF") return null;

  if (!currentStaff) {
    throw new Error("Could not get current staff");
  }

  return currentStaff as StaffType;
};
